import { useTranslation } from 'react-i18next';
import { localizeSystemText } from '../../i18n/messages';
import LocalizedMessage from './LocalizedMessage';
import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const SearchableSelect = ({
  name,
  label,
  value,
  error,
  options,
  readOnly,
  onChange,
  className,
  placeholder,
  clearValue,
  isClearable,
}) => {
  const { t } = useTranslation();
  const inputId = `${name}-searchable-select`;
  const selectOptions = options.map(option => ({
    value: option.value,
    label: option.text,
  }));
  const selectedOption = selectOptions.find(option => option.value === value) || null;
  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "calc(1.5em + 0.75rem + 2px)",
      borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      },
    }),
    valueContainer: provided => ({
      ...provided,
      padding: "0 0.75rem",
    }),
    input: provided => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: provided => ({
      ...provided,
      minHeight: "calc(1.5em + 0.75rem)",
    }),
  };

  const handleChange = selected => {
    onChange({
      target: {
        name,
        value: selected ? selected.value : clearValue,
      },
    });
  };

  return (
    <div className={`form-group ${className}`}>
      <label htmlFor={inputId} className="mb-0">
        <strong>{localizeSystemText(label, t)}</strong>
      </label>
      <div className="field mt-1">
        <Select
          inputId={inputId}
          value={selectedOption}
          onChange={handleChange}
          options={selectOptions}
          isDisabled={readOnly}
          isClearable={isClearable}
          placeholder={localizeSystemText(placeholder, t)}
          noOptionsMessage={() => t('common:noOptions')}
          classNamePrefix="searchable-select"
          styles={selectStyles}
        />
        {error && <div className="invalid-feedback d-block"><LocalizedMessage isError value={error} /></div>}
      </div>
    </div>
  );
};

SearchableSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ key: PropTypes.string.isRequired, params: PropTypes.object })]),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    text: PropTypes.string.isRequired,
  })),
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  clearValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isClearable: PropTypes.bool,
};

SearchableSelect.defaultProps = {
  value: "",
  error: "",
  options: [],
  readOnly: false,
  className: "",
  placeholder: "Wybierz...",
  clearValue: "",
  isClearable: true,
};

export default SearchableSelect;
